import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { CyclicTabbingSiteConfig } from '../types'

const cyclicTabbingSiteConfig: SiteConfigFn<CyclicTabbingSiteConfig> = ({ api }) => {
	const isBuilderComponentModel = api.rendererModel.getIsBuilderComponentModel() ?? false

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig: {
			isBuilderComponentModel,
		},
	}
}

export const name = 'cyclicTabbing'

export const config = { site: cyclicTabbingSiteConfig, reactRendererSite: cyclicTabbingSiteConfig, name }
